import type { CreatePartyValues } from './types';

export default function toPartyAddress(address: CreatePartyValues['address']) {
  const street = address?.street?.trim();
  const housenr = address?.housenr?.trim();
  const countryCode = address?.country_code;

  if (!street || !housenr || !countryCode) return undefined;

  return {
    street,
    housenr,
    boxnr: address?.boxnr?.trim() || undefined,
    zipcode: address?.zipcode?.trim() || undefined,
    city: address?.city?.trim() || undefined,
    country_code: countryCode,
  };
}
